import React from 'react';
import cn from 'classnames';
import "./Breadcrumbs.css";
var styles = { "container": "e0fe54" };
import BreadcrumbList from '../shared/components/BreadcrumbList';
const Breadcrumbs = ({ links = [], alignment = 'center', spacing = 'narrow', separator = '/', labels, onItemClick, className, shouldHideBreadcrumbs = false, shouldCapitalizeText = false, shouldHighlightLastItem = false, }) => {
    if (!(links === null || links === void 0 ? void 0 : links.length) || shouldHideBreadcrumbs)
        return null;
    return (React.createElement("nav", { className: cn(styles.container, className, alignment && styles[alignment]), "aria-label": (labels === null || labels === void 0 ? void 0 : labels['breadcrumb.arialabel.breadcrumb']) || 'Breadcrumb' },
        React.createElement(BreadcrumbList, { variant: "hm", links: links, shouldCapitalizeText: shouldCapitalizeText, spacing: spacing, separator: separator, onItemClick: onItemClick, alignment: alignment, shouldHighlightLastItem: shouldHighlightLastItem })));
};
export default Breadcrumbs;
//# sourceMappingURL=Breadcrumbs.js.map